import { render, staticRenderFns } from "./cadastroPage.vue?vue&type=template&id=3cd21509&scoped=true"
import script from "./cadastroPage.vue?vue&type=script&lang=js"
export * from "./cadastroPage.vue?vue&type=script&lang=js"
import style0 from "./cadastroPage.vue?vue&type=style&index=0&id=3cd21509&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd21509",
  null
  
)

export default component.exports